import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PullCartIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Pull Cart`}
    {...props}
    testID="pull-cart-icon"
  >
    <G
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#a)"
      fill="none"
    >
      <Path d="M6.95 12.2h3.15l-7-7H1" fill="none" />
      <Path
        fill="none"
        d="M3.1 12.55a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM4.5 10.8V6.95M13.6 10.1l-2.8 2.8L5.9 8l2.8-2.8 4.9 4.9ZM15 12.9l-1.4 1.4-1.4-1.4 1.4-1.4 1.4 1.4ZM7.3 5.9 5.2 3.8m0 0-.7-.7 1.4-1.4c.583.35.7.7-.7 2.1Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
